module.exports = __webpack_public_path__ + "static/media/pickleball.768eeba1.svg";